export default "__VITE_PUBLIC_ASSET__65984e06__"